import "moment/locale/fr-ca";

import { toLower } from "lodash";
import moment from "moment";
import { DEFAULT_LOCALE } from "PFCore/helpers/date";
import { useEffect } from "react";

// TODO: [PROF-5207] update when movin currentProfile to react query
export const useGlobalsForLocale = (store) => {
  const { currentProfile } = store;
  const locale = currentProfile?.locale || DEFAULT_LOCALE;

  useEffect(() => {
    moment.locale(toLower(locale), {
      week: {
        dow: 1 // Monday is the first day of the week.
      }
    });
  }, [locale]);
};
